var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('LimitlessPageHeader'),_vm._v(" "),_c('div',{staticClass:"content"},[_c('h1',[_vm._v("Välkommen "+_vm._s(_vm.user.name))]),_vm._v(" "),_c('dashboard-calendar')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }